import { ElementMatcher } from './common/ElementMatcher';
export class FormValidator {
    constructor(win = window) {
        this.win = win;
        this.forms = new Set();
    }
    activate() {
        this.win.document.addEventListener('submit', (event) => {
            ElementMatcher.emittedBy(event, 'form[data-validate]', (e) => this.validate(event, e));
        });
        this.win.document.querySelectorAll('form[data-validate]')
            .forEach(form => form.noValidate = true);
    }
    validate(event, form) {
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.forms.has(form)) {
            this.forms.add(form);
            this.registerFormListener(form);
        }
        this.addValidClass(form);
        this.addInvalidClass(form);
        form.classList.add('validated');
    }
    registerFormListener(form) {
        form.addEventListener('input', (event) => this.handleInputEvent(form, event));
    }
    handleInputEvent(form, event) {
        if (event.target instanceof HTMLElement) {
            const input = event.target;
            if (input.classList.contains('valid')) {
                this.removeClassRec('valid', form, input);
            }
            else if (input.classList.contains('invalid')) {
                this.removeClassRec('invalid', form, input);
            }
        }
    }
    addValidClass(form) {
        form.querySelectorAll(':valid')
            .forEach(el => {
            this.removeClassRec('invalid', form, el);
            this.addClassRec('valid', form, el);
            el.classList.add('validated');
        });
    }
    addInvalidClass(form) {
        form.querySelectorAll(':invalid')
            .forEach(el => {
            this.removeClassRec('valid', form, el);
            this.addClassRec('invalid', form, el);
            el.classList.add('validated');
        });
    }
    addClassRec(className, parent, child) {
        child.classList.add(className);
        if (child === parent || !child.parentElement)
            return;
        this.addClassRec(className, parent, child.parentElement);
    }
    removeClassRec(className, parent, child) {
        child.classList.remove(className);
        if (child === parent || !child.parentElement)
            return;
        this.removeClassRec(className, parent, child.parentElement);
    }
}
